import interview from "@/components/interview/Interview";
import interviewIndex from "@/components/interview/Index";
import interviewEdit from "@/components/interview/Edit";
import interviewPool from "@/components/interview/Pool";
import interviewCreate from "@/components/interview/Create";
import interviewEditDetails from "@/components/interview/EditDetails";
import interviewLog from "@/components/interview/Log";
import interviewDoctors from "@/components/interview/Doctors";
import createDoctor from "@/components/interview/DoctorCreate";
import editDoctor from "@/components/interview/DoctorEdit";

export default {
  path: "/interview",
  component: interview,
  meta: {
    permission: "interview:create|interview:manage|interview:read"
  },
  children: [
    {
      path: "",
      name: "interview-index",
      component: interviewIndex,
      meta: {
        title: "Interview Index",
        permission: "interview:create|interview:manage|interview:read"
      }
    },
    {
      path: "edit/:id",
      name: "interview-edit",
      component: interviewEdit,
      props: true,
      meta: {
        title: "Interview Edit",
        permission: "interview:create|interview:manage"
      }
    },
    {
      path: "edit/:id",
      name: "interview-edit-id",
      component: interviewEdit,
      props: true,
      meta: {
        title: "Interview Edit",
        permission: "interview:create|interview:manage"
      }
    },
    {
      path: "pool",
      name: "interview-pool",
      component: interviewPool,
      meta: {
        title: "Interview Templates",
        permission: "interview:create|interview:manage"
      }
    },
    {
      path: "create",
      name: "interview-create",
      component: interviewCreate,
      meta: {
        title: "Interview Create",
        permission: "interview:create|interview:manage"
      }
    },
    {
      path: "edit-details/:id",
      name: "interview-edit-details",
      component: interviewEditDetails,
      props: true,
      meta: {
        title: "Interview Edit Details",
        permission: "interview:create|interview:manage"
      }
    },
    {
      path: "log/:id",
      name: "interview-log",
      component: interviewLog,
      props: true,
      meta: {
        title: "Interview Log",
        permission: "interview:read|interview:create|interview:manage"
      }
    },
    {
      path: "providers/:id",
      name: "interview-providers",
      component: interviewDoctors,
      props: true,
      meta: {
        title: "Interview Provider",
        permission: "interview:read|interview:create|interview:manage"
      }
    },
    {
      path: "providers/:id/create",
      name: "interview-providers-create",
      component: createDoctor,
      props: true,
      meta: {
        title: "Create Interview Provider",
        permission: "interview:read|interview:create|interview:manage"
      }
    },
    {
      path: "providers/:id/edit/:doctorId",
      name: "interview-providers-edit",
      component: editDoctor,
      props: true,
      meta: {
        title: "Edit Interview Provider",
        permission: "interview:read|interview:create|interview:manage"
      }
    }
  ]
};
